import React from 'react';
import { IconButton, mergeStyleSets, FontSizes, FontWeights } from '@fluentui/react';

import office from 'src/services/office';
import { runShortAction } from 'src/services/utils';


const classNames = mergeStyleSets({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    fontSize: '24px',
  },
  range: {
    fontSize: FontSizes.medium,
    fontWeight: FontWeights.semibold,
    leftMargin: '20px',
  },
});


export const TargetPickerButton = ({ iconName = 'xappex-target', disabled, onChange, selectionOnly = false }) => {
  const handleClick = async () => {
    await runShortAction(async () => {
      const t = await (selectionOnly ? office.getSelectedRanges() : office.getFlowstepTarget());
      onChange?.(t);        
    });
  }

  return (
    <IconButton 
      disabled={disabled}
      iconProps={{ iconName, styles: { root: classNames.icon } }} 
      onClick={handleClick} 
    />
  );
}


export const TargetPicker = ({ onChange, disabled, target, selectionOnly = false, showRange = true }) => {
  const range = target?.table
    ? `${target.worksheetName}!${target.table.rangeAddress}`
    : 'not found';

  return (
    <div className={classNames.root}>
      <TargetPickerButton selectionOnly={selectionOnly} disabled={disabled} onChange={onChange} />
      { showRange && !selectionOnly && target &&
        <span className={classNames.range}>{`Range: ${range}`}</span>
      }
    </div>
  );
}


export default TargetPicker;